import { render, staticRenderFns } from "./_LinkPublication.vue?vue&type=template&id=40493220&scoped=true&"
import script from "./_LinkPublication.vue?vue&type=script&lang=js&"
export * from "./_LinkPublication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40493220",
  null
  
)

/* custom blocks */
import block0 from "./_LinkPublication.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/render/project/src/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {VBtn,VCardActions,VFlex,VIcon})
